"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var change_emitter_1 = require("change-emitter");
var Observable = require("zen-observable");
var utils_1 = require("./utils");
var MessageType;
(function (MessageType) {
    MessageType[MessageType["Value"] = 0] = "Value";
    MessageType[MessageType["Error"] = 1] = "Error";
    MessageType[MessageType["Complete"] = 2] = "Complete";
})(MessageType || (MessageType = {}));
var VersionWatcher = (function (_super) {
    __extends(VersionWatcher, _super);
    function VersionWatcher(baseServiceUrl, _sampleInterval) {
        if (_sampleInterval === void 0) { _sampleInterval = 30; }
        var _this = _super.call(this, function (observer) {
            if (_this._isDisposed) {
                observer.complete();
            }
            _this._watchVersion();
            function observeVersion(_a) {
                var type = _a.type, payload = _a.payload;
                switch (type) {
                    case MessageType.Value:
                        observer.next(payload);
                        break;
                    case MessageType.Error:
                        observer.error(payload);
                        break;
                    case MessageType.Complete:
                        observer.complete();
                        break;
                }
            }
            if (_this._currentVersion) {
                observeVersion({ type: MessageType.Value, payload: _this._currentVersion });
            }
            return _this._emitter.listen(observeVersion);
        }) || this;
        _this._sampleInterval = _sampleInterval;
        _this._emitter = change_emitter_1.createChangeEmitter();
        _this._startedWatching = false;
        _this._isDisposed = false;
        if (!baseServiceUrl.endsWith('/')) {
            baseServiceUrl += '/';
        }
        _this._versionUrl = baseServiceUrl + "status";
        return _this;
    }
    Object.defineProperty(VersionWatcher.prototype, "currentVersion", {
        get: function () {
            return this._currentVersion;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VersionWatcher.prototype, "isDisposed", {
        get: function () {
            return this._isDisposed;
        },
        enumerable: true,
        configurable: true
    });
    VersionWatcher.prototype.dispose = function () {
        this._isDisposed = true;
    };
    VersionWatcher.prototype._emit = function (message) {
        this._emitter.emit(message);
    };
    VersionWatcher.prototype._watchVersion = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, status_1, version, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this._startedWatching) {
                            return [2];
                        }
                        this._startedWatching = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 8, , 9]);
                        _a.label = 2;
                    case 2:
                        if (!!this._isDisposed) return [3, 7];
                        return [4, fetch(this._versionUrl)];
                    case 3:
                        result = _a.sent();
                        if (!result.ok) return [3, 5];
                        return [4, result.json()];
                    case 4:
                        status_1 = _a.sent();
                        version = status_1 && status_1['repository revision'];
                        if (version && version !== this._currentVersion) {
                            this._currentVersion = version;
                            this._emit({ type: MessageType.Value, payload: version });
                        }
                        _a.label = 5;
                    case 5:
                        if (this._isDisposed)
                            return [3, 7];
                        return [4, utils_1.delay(this._sampleInterval)];
                    case 6:
                        _a.sent();
                        return [3, 2];
                    case 7:
                        this._emit({ type: MessageType.Complete });
                        return [3, 9];
                    case 8:
                        error_1 = _a.sent();
                        this._emit({ type: MessageType.Error, payload: error_1 });
                        return [3, 9];
                    case 9: return [2];
                }
            });
        });
    };
    return VersionWatcher;
}(Observable));
exports.VersionWatcher = VersionWatcher;
//# sourceMappingURL=VersionWatcher.js.map


// WEBPACK FOOTER //
// ../src/VersionWatcher.ts